module.exports = __webpack_public_path__ + "img/moon2.f177b789.svg";